import { render, staticRenderFns } from "./ManageProject.vue?vue&type=template&id=1af786c6&scoped=true"
import script from "./ManageProject.vue?vue&type=script&lang=js"
export * from "./ManageProject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af786c6",
  null
  
)

export default component.exports